import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import ArtistPage from './comp/ArtistPage.js';
import WorksPage from './comp/WorksPage.js';
import LandingPage from './comp/LandingPage.js';
import ContactPage from './comp/ContactPage.js';
import NavbarModal from './comp/NavbarModal.js';

import { useState } from 'react';
import { useData } from './DataProvider';

const App = () => {

  const [currentPage, setCurrentPage] = useState('home');

  const [isNavbarModalOpen, setIsNavbarModalOpen] = useState(false);
  const { data, loading } = useData();

  const openNavbarModal = () => {
    setIsNavbarModalOpen(true);
  };

  const closeNavbarModal = () => {
    setIsNavbarModalOpen(false);
  };

  const toggleNavbarModal = () => {
    if (isNavbarModalOpen)
      closeNavbarModal();
    else
      openNavbarModal();
  }


  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'ARTISTS':
        return <ArtistPage />;
      case 'WORKS':
        return <WorksPage />;
      case 'MINIMA':
        return <LandingPage />;
      case 'CONTACT':
        return <ContactPage />;
      default:
        return <LandingPage />;
    }
  };


  function createAudioPage() {
    if(loading)
      return (<></>);

    return (<div style={{ display: 'none' }}>
      {data.works.map(item => {
        return (<audio preload="auto" id={item['title']}>
          <source src={item['music-filename']} />
          Your browser does not support the audio format.
        </audio>)
      })}
    </div>)
  }

  return (
    <div className="App">
      {createAudioPage()}
      <Navbar bg="black" data-bs-theme="dark" sticky="top" >
        <Container className="navbar-wrapper">
          <Navbar.Brand href="#home" onClick={() => handlePageChange('MINIMA')} style={{ fontSize: '18px' }}>MINIMA</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link className='hide-mobile' href="#artists" onClick={() => handlePageChange('ARTISTS')} style={{ fontSize: '18px' ,userSelect: 'none', cursor: 'pointer' }}>ARTISTS</Nav.Link>
              <Nav.Link className='hide-mobile' href="#works" onClick={() => handlePageChange('WORKS')} style={{ fontSize: '18px',userSelect: 'none', cursor: 'pointer' }}>WORKS</Nav.Link>
              <Nav.Link className='hide-mobile' href="#contact" onClick={() => handlePageChange('CONTACT')} style={{ fontSize: '18px' ,userSelect: 'none', cursor: 'pointer'}}>CONTACT</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <div className='navbar-button' onClick={toggleNavbarModal}>
            {!isNavbarModalOpen ?
              (<svg xmlns="http://www.w3.org/2000/svg" width="22" height="8" shape-rendering="crispEdges"><path fill="#FFF" d="M0 0h1v1H0zM1 0h1v1H1zM2 0h1v1H2zM3 0h1v1H3zM4 0h1v1H4zM5 0h1v1H5zM6 0h1v1H6zM7 0h1v1H7zM8 0h1v1H8zM9 0h1v1H9zM10 0h1v1h-1zM11 0h1v1h-1zM12 0h1v1h-1zM13 0h1v1h-1zM14 0h1v1h-1zM15 0h1v1h-1zM16 0h1v1h-1zM17 0h1v1h-1zM18 0h1v1h-1zM19 0h1v1h-1zM20 0h1v1h-1zM21 0h1v1h-1zM0 1h1v1H0zM1 1h1v1H1zM2 1h1v1H2zM3 1h1v1H3zM4 1h1v1H4zM5 1h1v1H5zM6 1h1v1H6zM7 1h1v1H7zM8 1h1v1H8zM9 1h1v1H9zM10 1h1v1h-1zM11 1h1v1h-1zM12 1h1v1h-1zM13 1h1v1h-1zM14 1h1v1h-1zM15 1h1v1h-1zM16 1h1v1h-1zM17 1h1v1h-1zM18 1h1v1h-1zM19 1h1v1h-1zM20 1h1v1h-1zM21 1h1v1h-1zM0 6h1v1H0zM1 6h1v1H1zM2 6h1v1H2zM3 6h1v1H3zM4 6h1v1H4zM5 6h1v1H5zM6 6h1v1H6zM7 6h1v1H7zM8 6h1v1H8zM9 6h1v1H9zM10 6h1v1h-1zM11 6h1v1h-1zM12 6h1v1h-1zM13 6h1v1h-1zM14 6h1v1h-1zM15 6h1v1h-1zM16 6h1v1h-1zM17 6h1v1h-1zM18 6h1v1h-1zM19 6h1v1h-1zM20 6h1v1h-1zM21 6h1v1h-1zM0 7h1v1H0zM1 7h1v1H1zM2 7h1v1H2zM3 7h1v1H3zM4 7h1v1H4zM5 7h1v1H5zM6 7h1v1H6zM7 7h1v1H7zM8 7h1v1H8zM9 7h1v1H9zM10 7h1v1h-1zM11 7h1v1h-1zM12 7h1v1h-1zM13 7h1v1h-1zM14 7h1v1h-1zM15 7h1v1h-1zM16 7h1v1h-1zM17 7h1v1h-1zM18 7h1v1h-1zM19 7h1v1h-1zM20 7h1v1h-1zM21 7h1v1h-1z" /></svg>)
              :
              (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="22" height="22">
                <line x1="2" y1="2" x2="20" y2="20" stroke="white" stroke-width="2" />
                <line x1="2" y1="20" x2="20" y2="2" stroke="white" stroke-width="2" />
              </svg>
              )}
          </div>
        </Container>
      </Navbar>

      <NavbarModal isOpen={isNavbarModalOpen} onRequestClose={closeNavbarModal} state={currentPage} onStateChange={handlePageChange} />
      <div className="App-page">
        {renderPage()}
      </div>
    </div>
  );
}

export default App;
